import { useRouter } from "@edreamsodigeo/frontend-core";

const useIsGoogleDisabled = (): boolean => {
  const { query } = useRouter();

  const { hg: hideGoogle } = query;

  return hideGoogle === "true";
};

export default useIsGoogleDisabled;
